import { render } from "./AnnexAlarmsPage.vue?vue&type=template&id=e01662a2&ts=true"
import script from "./AnnexAlarmsPage.vue?vue&type=script&lang=ts"
export * from "./AnnexAlarmsPage.vue?vue&type=script&lang=ts"

import "./AnnexAlarmsPage.vue?vue&type=style&index=0&id=e01662a2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__